/**
 * ═══════════════════════════════════════════════════════════════
 * CORE APPLICATION IMAGES - SINGLE SOURCE OF TRUTH
 * ═══════════════════════════════════════════════════════════════
 *
 * PURPOSE: Centralized image path definitions for easy maintenance
 *
 * HOW TO USE:
 * 1. Import in components: import { LOGO } from '../constants/images';
 * 2. Use in JSX: <img src={LOGO} alt="Logo" />
 * 3. Or use hook: const images = useImages(); <img src={images.LOGO} />
 *
 * HOW TO UPDATE GLOBALLY:
 * - Option A: Replace the file in public/images/ directory
 * - Option B: Change the path here (all components auto-update)
 *
 * HOW TO ADD NEW IMAGE:
 * 1. Add file to public/images/
 * 2. Add constant here: NEW_IMAGE: '/images/new-image.png'
 * 3. Add to destructuring export at bottom
 * 4. Import where needed
 *
 * THEME INTEGRATION:
 * - These are CORE images (used by all themes by default)
 * - Themes can OVERRIDE in themes.js if needed
 * - useImages() hook merges core + theme images at runtime
 * ═══════════════════════════════════════════════════════════════
 */

export const IMAGES = {
  // ━━━ BRANDING ━━━
  LOGO: '/images/btm_lantern.png',           // Main app logo (currently in Header.js)
  LOGO_MONO: '/images/btm_lantern_mono.png', // Monochrome variant (unused currently)
  LOGO_CIRCLE: '/images/btm-circle-logo.png', // Circle logo for landing page
  BANNER: '/images/brings_to_mind_banner.png', // Banner image (unused currently)

  // ━━━ BACKGROUNDS ━━━
  BACKGROUND_WAVES: '/images/waves_blue_abstract.jpg', // Decorative background (unused currently)
  BACKGROUND_WAVES_GRAY: '/images/waves_gray_abstract.png', // Grayscale wave background for theme blending

  // ━━━ PLACEHOLDERS (for future use) ━━━
  // VIDEO_PLACEHOLDER: '/images/placeholders/video.jpg',
  // AUDIO_PLACEHOLDER: '/images/placeholders/audio.jpg',
};

// Helper function to get image by key (alternative access method)
export const getImage = (key) => IMAGES[key];

// Named exports for convenience - allows: import { LOGO, BANNER } from './images'
export const {
  LOGO,
  LOGO_MONO,
  LOGO_CIRCLE,
  BANNER,
  BACKGROUND_WAVES,
  BACKGROUND_WAVES_GRAY
} = IMAGES;

// Default export for flexibility - allows: import IMAGES from './images'
export default IMAGES;
